import Vue from 'vue'
import Vuex from 'vuex'

import { orderBy } from 'lodash'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  featuredClients: window.pageData.homeIndex.featuredClients,
  pageContent: window.pageData.homeIndex.pageContent,
  searchFormContent: window.pageData.homeIndex.searchFormContent,
  testimonials: window.pageData.homeIndex.testimonials,
  urls: window.pageData.homeIndex.urls
}

const mutations = {}

const getters = {
  featuredClientsSorted (state) {
    return orderBy(state.featuredClients, 'SortOrder')
  },
  testimonialsSorted (state) {
    return orderBy(state.testimonials, 'SortOrder')
  }
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  strict: debug
})



// WEBPACK FOOTER //
// ./WebResources/vue/pictureday/home/index/store.js